import { ChipMetadata, Tooltip } from '@pmi/dsm-react';
import { CircleInfoIcon } from '@pmi/dsm-react/dist/components/icons/16';
import styles from './optedOutChip.module.scss';

interface OptedOutChipProps {
  isInternalAdmin: boolean;
  shareData?: boolean | null;
}

export default function OptedOutChip({
  isInternalAdmin,
  shareData,
}: OptedOutChipProps) {
  if (!isInternalAdmin || shareData !== false) return null;

  return (
    <span className="d-block mt-1">
      <Tooltip
        type="sm"
        content="DO NOT SHARE product data including exam result, exam date, status, progress and completion with people outside PMI"
        placement="top"
        className="darkTooltip"
        overlay={{ className: styles.tooltip }}
        trigger={['hover', 'focus', 'click']}
      >
        <ChipMetadata
          text="Opted Out"
          icon={<CircleInfoIcon />}
          variant="red"
        />
      </Tooltip>
    </span>
  );
}
